import React, { useEffect, useState, createContext, useContext } from 'react';
import { motion } from 'framer-motion';
type Locale = 'en' | 'es';
interface Translations {
  [key: string]: {
    en: string;
    es: string;
  };
}
const translations: Translations = {
  // Navbar
  'nav.shop': {
    en: 'Shop',
    es: 'Tienda'
  },
  'nav.helpMeChoose': {
    en: 'Help Me Choose',
    es: 'Ayúdame a Elegir'
  },
  'nav.compareMaterials': {
    en: 'Compare Materials',
    es: 'Comparar Materiales'
  },
  'nav.deliveryZones': {
    en: 'Delivery Zones',
    es: 'Zonas de Entrega'
  },
  'nav.calculator': {
    en: 'Calculator',
    es: 'Calculadora'
  },
  'nav.about': {
    en: 'About',
    es: 'Nosotros'
  },
  'nav.contact': {
    en: 'Contact',
    es: 'Contacto'
  },
  // Hero
  'hero.exploreCatalog': {
    en: 'Explore Our Catalog',
    es: 'Explorar Catálogo'
  },
  'hero.getEstimate': {
    en: 'Get Instant Estimate',
    es: 'Obtener Presupuesto'
  },
  'hero.trust.phone': {
    en: 'Order from your phone in minutes',
    es: 'Ordena desde tu teléfono en minutos'
  },
  'hero.trust.fees': {
    en: 'No hidden fees',
    es: 'Sin tarifas ocultas'
  },
  'hero.trust.pay': {
    en: 'Pay on delivery',
    es: 'Paga al recibir'
  },
  'hero.trustedBy': {
    en: "Order Gravel Like It's 2026",
    es: 'De confianza en el 206 y más allá'
  },
  'hero.deliveriesCount': {
    en: '200+ deliveries',
    es: '200+ entregas'
  },
  'hero.deliveriesLabel': {
    en: 'Deliveries completed',
    es: 'Entregas completadas'
  },
  'hero.deliveriesWord': {
    en: 'deliveries',
    es: 'entregas'
  },
  'hero.feat.deliveryDate': {
    en: 'Choose Your Delivery Date',
    es: 'Elige Tu Fecha de Entrega'
  },
  'hero.feat.estimates': {
    en: 'Instant Estimates',
    es: 'Presupuestos Instantáneos'
  },
  'hero.feat.bulk': {
    en: 'Smart Bulk Discounts',
    es: 'Descuentos por Volumen'
  },
  'hero.feat.compare': {
    en: 'Compare Materials',
    es: 'Comparar Materiales'
  },
  'hero.headlineLine1': {
    en: "Sun's Out, Trucks Out.",
    es: 'Sol Afuera, Camiones Listos.'
  },
  'hero.headlineLine2': {
    en: "Let's Get It Done.",
    es: 'Manos a la Obra.'
  },
  'hero.subtitle': {
    en: 'The smartest way to order gravel, topsoil, and landscaping materials — instant estimates and automatic bulk pricing from your phone.',
    es: 'La forma más inteligente de pedir grava, tierra vegetal y materiales de paisajismo — presupuestos instantáneos y precios al mayoreo automáticos desde tu teléfono.'
  },
  // Hero Estimator & Dispatch
  'hero.estimator.browseCatalog': {
    en: 'Or browse the full catalog',
    es: 'O explora el catálogo completo'
  },
  'hero.estimator.shopByProject': {
    en: 'Shop by project',
    es: 'Comprar por proyecto'
  },
  'hero.estimator.browseFullCatalog': {
    en: 'Browse catalog',
    es: 'Ver catálogo'
  },
  'hero.estimator.label': {
    en: 'Get an Instant Estimate',
    es: 'Obtén un Presupuesto Instantáneo'
  },
  'hero.estimator.step1': {
    en: 'Where are we delivering?',
    es: '¿A dónde entregamos?'
  },
  'hero.estimator.addressPlaceholder': {
    en: '123 Main St, Tacoma, WA',
    es: '123 Main St, Tacoma, WA'
  },
  'hero.estimator.step2': {
    en: 'What and how much?',
    es: '¿Qué y cuánto?'
  },
  'hero.estimator.addressNotFound': {
    en: 'Address not found. Try a more specific address.',
    es: 'Dirección no encontrada. Intenta con una dirección más específica.'
  },
  'hero.estimator.addressError': {
    en: 'Could not verify address. Please try again.',
    es: 'No se pudo verificar la dirección. Por favor, intenta de nuevo.'
  },
  'hero.estimator.freeDelivery': {
    en: 'Free delivery',
    es: 'Entrega gratis'
  },
  'hero.estimator.plusDelivery': {
    en: 'delivery',
    es: 'de entrega'
  },
  'hero.estimator.outsideZones': {
    en: "Outside standard zones — we'll quote you a custom rate.",
    es: 'Fuera de las zonas estándar — te cotizaremos una tarifa personalizada.'
  },
  'hero.estimator.quizLink': {
    en: 'Take the 30-sec material quiz →',
    es: 'Toma el cuestionario de materiales de 30 segundos →'
  },
  'hero.estimator.multiLoadInfo': {
    en: 'Multi-load orders require separate deliveries. You will be charged a delivery fee per load.',
    es: 'Los pedidos de múltiples cargas requieren entregas separadas. Se te cobrará una tarifa de entrega por carga.'
  },
  'hero.estimator.qty.yards': {
    en: 'Yards',
    es: 'Yardas'
  },
  'hero.estimator.qty.fullLoad': {
    en: 'Yards (Full Load)',
    es: 'Yardas (Carga Completa)'
  },
  'hero.estimator.qty.moreThanOne': {
    en: 'More than 1 load',
    es: 'Más de 1 carga'
  },
  'hero.estimator.qty.howManyLoads': {
    en: 'How many loads?',
    es: '¿Cuántas cargas?'
  },
  'hero.estimator.qty.loads': {
    en: 'Loads',
    es: 'Cargas'
  },
  'hero.estimator.qty.customQuote': {
    en: 'Loads (Custom Quote)',
    es: 'Cargas (Cotización Personalizada)'
  },
  'hero.estimator.secureInfo': {
    en: 'Your information is secure',
    es: 'Tu información está segura'
  },
  'hero.dispatch.active': {
    en: 'Dispatch Active',
    es: 'Despacho Activo'
  },
  'hero.dispatch.closedSundays': {
    en: 'Dispatch Closed Sundays',
    es: 'Despacho Cerrado los Domingos'
  },
  'hero.dispatch.opens5am': {
    en: 'Dispatch Opens 5 AM',
    es: 'Despacho Abre a las 5 AM'
  },
  'hero.dispatch.opens7am': {
    en: 'Dispatch Opens 7 AM',
    es: 'Despacho Abre a las 7 AM'
  },
  'hero.dispatch.opensSat7am': {
    en: 'Dispatch Opens Sat 7 AM',
    es: 'Despacho Abre el Sáb a las 7 AM'
  },
  'hero.quote.breakdown': {
    en: 'Price Breakdown',
    es: 'Desglose de Precios'
  },
  'hero.quote.material': {
    en: 'Material',
    es: 'Material'
  },
  'hero.quote.smallLoadUpcharge': {
    en: 'Includes small load upcharge',
    es: 'Incluye recargo por carga pequeña'
  },
  'hero.quote.bulkDiscount': {
    en: 'bulk discount applied',
    es: 'descuento por volumen aplicado'
  },
  'hero.quote.delivery': {
    en: 'Delivery',
    es: 'Entrega'
  },
  'hero.quote.zone': {
    en: 'Zone',
    es: 'Zona'
  },
  'hero.quote.customQuote': {
    en: 'Custom Quote',
    es: 'Cotización Personalizada'
  },
  'hero.quote.estimatedTotal': {
    en: 'Estimated Total',
    es: 'Total Estimado'
  },
  'hero.quote.callToOrder': {
    en: 'Call to Order',
    es: 'Llamar para Ordenar'
  },
  'hero.quote.view': {
    en: 'View',
    es: 'Ver'
  },
  'hero.quote.deliveryFeeNote': {
    en: 'Delivery fee based on your',
    es: 'Tarifa de entrega basada en tu'
  },
  'hero.quote.deliveryZoneLink': {
    en: 'delivery zone',
    es: 'zona de entrega'
  },
  'hero.quote.outsideZonesNote': {
    en: 'Your address is outside standard zones. Delivery fee may apply —',
    es: 'Tu dirección está fuera de las zonas estándar. Puede aplicar tarifa de entrega —'
  },
  'hero.quote.checkZonesLink': {
    en: 'check delivery zones',
    es: 'revisar zonas de entrega'
  },
  'hero.quote.startOver': {
    en: 'Start over ↻',
    es: 'Empezar de nuevo ↻'
  },
  'hero.pill.30min': {
    en: '30 Min from Your Driveway',
    es: 'A 30 Min de tu Entrada'
  },
  // Credentials
  'credentials.eyebrow': {
    en: 'Credentials You Can Verify',
    es: 'Credenciales que Puedes Verificar'
  },
  'credentials.licensed': {
    en: 'Licensed & Bonded',
    es: 'Licenciado y Afianzado'
  },
  'credentials.insured': {
    en: 'Fully Insured',
    es: 'Totalmente Asegurado'
  },
  'credentials.wsdot': {
    en: 'WSDOT-Registered',
    es: 'Registrado en WSDOT'
  },
  'credentials.bbb': {
    en: 'BBB Accredited',
    es: 'Acreditado por BBB'
  },
  'credentials.family': {
    en: 'Family Owned',
    es: 'Propiedad Familiar'
  },
  'credentials.permitted': {
    en: 'Permitted Bulk Hauler',
    es: 'Transportista a Granel Autorizado'
  },
  'credentials.rating': {
    en: 'A+ Rating',
    es: 'Calificación A+'
  },
  // Track Order
  'track.title': {
    en: 'Track Your Order',
    es: 'Rastrea tu Orden'
  },
  'track.subtitle': {
    en: 'Enter your order number to see live status, ETA, and driver info.',
    es: 'Ingresa tu número de orden para ver el estado en vivo, ETA y la información del conductor.'
  },
  'track.recentOrder': {
    en: 'Your most recent order',
    es: 'Tu orden más reciente'
  },
  'track.orderNum': {
    en: 'Order #',
    es: 'Orden #'
  },
  'track.continue': {
    en: 'Continue',
    es: 'Continuar'
  },
  'track.lookupAnother': {
    en: 'Look up another order',
    es: 'Buscar otra orden'
  },
  'track.enterOrder': {
    en: 'Enter your order number',
    es: 'Ingresa tu número de orden'
  },
  'track.placeholder': {
    en: 'e.g. 206-A1B2C3',
    es: 'ej. 206-A1B2C3'
  },
  'track.button': {
    en: 'Track Order',
    es: 'Rastrear Orden'
  },
  'track.note': {
    en: 'Your order number was sent to you by SMS and email when you placed your order.',
    es: 'Tu número de orden te fue enviado por SMS y correo electrónico cuando realizaste tu pedido.'
  },
  'track.help.title': {
    en: "Can't find your order number?",
    es: '¿No encuentras tu número de orden?'
  },
  'track.help.call': {
    en: 'Call dispatch — (206) 619-3742',
    es: 'Llama a despacho — (206) 619-3742'
  },
  // SMS Order
  'sms.header.eyebrow': {
    en: 'Built for the Jobsite',
    es: 'Construido para el Sitio de Trabajo'
  },
  'sms.header.title1': {
    en: 'Text us your order — ',
    es: 'Envíanos tu orden por texto — '
  },
  'sms.header.title2': {
    en: 'no app, no form.',
    es: 'sin app, sin formulario.'
  },
  'sms.header.subtitleOpen': {
    en: 'Tap any preset or build a custom text order below.',
    es: 'Toca cualquier preajuste o crea una orden de texto personalizada abajo.'
  },
  'sms.header.subtitleClosed': {
    en: 'Tap to open the SMS order builder.',
    es: 'Toca para abrir el creador de órdenes por SMS.'
  },
  'sms.pitch.title1': {
    en: "You're on the jobsite.",
    es: 'Estás en el sitio de trabajo.'
  },
  'sms.pitch.title2': {
    en: "We're one tap away.",
    es: 'Estamos a un toque de distancia.'
  },
  'sms.pitch.desc': {
    en: 'Tap a preset or build your order in 10 seconds — your Messages app opens with everything pre-filled. Dispatch replies inside 10 minutes during business hours.',
    es: 'Toca un preajuste o crea tu orden en 10 segundos — tu app de Mensajes se abre con todo prellenado. Despacho responde en 10 minutos durante horas hábiles.'
  },
  'sms.pitch.bullet1': {
    en: 'Pre-formatted message — never miss a detail',
    es: 'Mensaje preformateado — nunca pierdas un detalle'
  },
  'sms.pitch.bullet2': {
    en: 'Replies from a real human, not a bot',
    es: 'Respuestas de un humano real, no de un bot'
  },
  'sms.pitch.bullet3': {
    en: 'Net-30 customers can just text "Repeat last"',
    es: 'Clientes Net-30 pueden simplemente textear "Repetir última"'
  },
  'sms.pitch.call': {
    en: 'Or call dispatch:',
    es: 'O llama a despacho:'
  },
  'sms.builder.dispatch': {
    en: '206Gravel Dispatch',
    es: 'Despacho 206Gravel'
  },
  'sms.builder.replies': {
    en: 'Replies typically within 10 min',
    es: 'Respuestas típicamente en 10 min'
  },
  'sms.builder.online': {
    en: 'Online',
    es: 'En línea'
  },
  'sms.builder.quickOrders': {
    en: 'Quick orders',
    es: 'Órdenes rápidas'
  },
  'sms.builder.material': {
    en: 'Material',
    es: 'Material'
  },
  'sms.builder.yards': {
    en: 'Yards',
    es: 'Yardas'
  },
  'sms.builder.dropAddress': {
    en: 'Drop address',
    es: 'Dirección de entrega'
  },
  'sms.builder.addressPlaceholder': {
    en: 'Jobsite address or city',
    es: 'Dirección del sitio o ciudad'
  },
  'sms.builder.when': {
    en: 'When',
    es: 'Cuándo'
  },
  'sms.builder.notes': {
    en: 'Notes (optional)',
    es: 'Notas (opcional)'
  },
  'sms.builder.notesPlaceholder': {
    en: 'Tight access, behind house...',
    es: 'Acceso estrecho, detrás de la casa...'
  },
  'sms.builder.preview': {
    en: 'Message preview',
    es: 'Vista previa del mensaje'
  },
  'sms.builder.to': {
    en: 'to',
    es: 'para'
  },
  'sms.builder.openMessages': {
    en: 'Open in Messages',
    es: 'Abrir en Mensajes'
  },
  'sms.builder.finePrint': {
    en: "Opens your phone's Messages app with the order pre-filled. You hit send.",
    es: 'Abre la app de Mensajes de tu teléfono con la orden prellenada. Tú presionas enviar.'
  },
  'sms.timing.asap': {
    en: 'ASAP today',
    es: 'Lo antes posible hoy'
  },
  'sms.timing.todayAm': {
    en: 'Today AM',
    es: 'Hoy AM'
  },
  'sms.timing.todayPm': {
    en: 'Today PM',
    es: 'Hoy PM'
  },
  'sms.timing.tomorrowAm': {
    en: 'Tomorrow AM',
    es: 'Mañana AM'
  },
  'sms.timing.tomorrowPm': {
    en: 'Tomorrow PM',
    es: 'Mañana PM'
  },
  'sms.timing.thisWeek': {
    en: 'This week',
    es: 'Esta semana'
  },
  // Reviews
  'reviews.testimonials': {
    en: 'Testimonials',
    es: 'Testimonios'
  },
  'reviews.trustedBy': {
    en: 'Trusted by the 206',
    es: 'De confianza en el 206'
  },
  'reviews.rating': {
    en: '4.9 from 250+ reviews',
    es: '4.9 de más de 250 reseñas'
  },
  'reviews.viewPhoto': {
    en: 'View photo',
    es: 'Ver foto'
  },
  // Cart Drawer
  'cart.title': {
    en: 'Your Truck',
    es: 'Tu Camión'
  },
  'cart.checkout': {
    en: 'Checkout',
    es: 'Pagar'
  },
  'cart.orderConfirmed': {
    en: 'Order Confirmed',
    es: 'Orden Confirmada'
  },
  'cart.continueShopping': {
    en: 'Continue Shopping',
    es: 'Seguir Comprando'
  },
  'cart.placeOrder': {
    en: 'Place Order',
    es: 'Realizar Pedido'
  },
  // Calculator
  'calc.title': {
    en: 'Volume Calculator',
    es: 'Calculadora de Volumen'
  },
  'calc.subtitle': {
    en: 'Estimate how much material you need for your project.',
    es: 'Estima cuánto material necesitas para tu proyecto.'
  },
  'calc.shape.rectangle': {
    en: 'Rectangle',
    es: 'Rectángulo'
  },
  'calc.shape.circle': {
    en: 'Circle',
    es: 'Círculo'
  },
  'calc.shape.triangle': {
    en: 'Triangle',
    es: 'Triángulo'
  },
  'calc.shape.irregular': {
    en: 'Irregular',
    es: 'Irregular'
  },
  'calc.length': {
    en: 'Length',
    es: 'Largo'
  },
  'calc.width': {
    en: 'Width',
    es: 'Ancho'
  },
  'calc.diameter': {
    en: 'Diameter',
    es: 'Diámetro'
  },
  'calc.base': {
    en: 'Base',
    es: 'Base'
  },
  'calc.height': {
    en: 'Height',
    es: 'Altura'
  },
  'calc.depth': {
    en: 'Depth',
    es: 'Profundidad'
  },
  'calc.result.yards': {
    en: 'Cubic Yards',
    es: 'Yardas Cúbicas'
  },
  'calc.result.tons': {
    en: 'Estimated Tons',
    es: 'Toneladas Estimadas'
  },
  // Announcement Bar
  'announce.bulkDelivery': {
    en: 'Bulk Same-Day Delivery Available',
    es: 'Entrega el Mismo Día a Granel Disponible'
  },
  'announce.bulkDeliveryShort': {
    en: 'Bulk Same-Day Delivery Available',
    es: 'Entrega Mismo Día a Granel Disponible'
  },
  'announce.contractors': {
    en: 'Contractors',
    es: 'Contratistas'
  },
  // Announcement bar slogans — one is picked at random per page load.
  // Curated from the site's established value-prop language so the bar
  // reinforces brand, never promotes a discount. Keep them SHORT — they
  // need to fit on a 320-wide mobile viewport alongside the phone link.
  'announce.slogan.sameDay': {
    en: 'Same-day delivery, dispatched fast',
    es: 'Entrega el mismo día, despachado rápido'
  },
  'announce.slogan.bulkDelivery': {
    en: 'Bulk same-day delivery available',
    es: 'Entrega el mismo día a granel disponible'
  },
  'announce.slogan.direct': {
    en: 'Order direct — skip the middleman',
    es: 'Ordena directo — sin intermediarios'
  },
  'announce.slogan.familyOwned': {
    en: 'Family-owned. Locally dispatched.',
    es: 'Empresa familiar. Despachado localmente.'
  },
  'announce.slogan.realTrucks': {
    en: 'Real prices. Real trucks. Real fast.',
    es: 'Precios reales. Camiones reales. Rápido de verdad.'
  },
  'announce.slogan.tacoma': {
    en: 'Gravel, topsoil & bark — delivered fast',
    es: 'Grava, tierra y corteza — entregado rápido'
  },
  'announce.trackOrder': {
    en: 'Track your delivery',
    es: 'Rastrea tu entrega'
  },
  'announce.trackOrderShort': {
    en: 'Track your delivery',
    es: 'Rastrea tu entrega'
  },
  // Local vs National
  'lvn.hero.eyebrow': {
    en: 'Local Supplier vs. National Marketplace',
    es: 'Proveedor Local vs. Marketplace Nacional'
  },
  'lvn.hero.title1': {
    en: 'Order Direct.',
    es: 'Ordena Directo.'
  },
  'lvn.hero.title2': {
    en: 'Skip the Middleman.',
    es: 'Sáltate al Intermediario.'
  },
  'lvn.hero.body': {
    en: "National marketplaces are brokers that route your order to whoever's cheapest. We are the local industry expert. When you order from 206Gravel, you're talking directly to the people loading and delivering your materials.",
    es: 'Los marketplaces nacionales son corredores que envían tu pedido a quien sea más barato. Nosotros somos el experto local de la industria. Cuando ordenas de 206Gravel, hablas directamente con las personas que cargan y entregan tus materiales.'
  },
  'lvn.hero.btnQuote': {
    en: 'Get Instant Estimate',
    es: 'Obtener Presupuesto'
  },
  'lvn.hero.btnCall': {
    en: 'Talk to Dispatch',
    es: 'Hablar con Despacho'
  },
  'lvn.advantage.title': {
    en: 'The Local Advantage',
    es: 'La Ventaja Local'
  },
  'lvn.advantage.subtitle': {
    en: 'See exactly why contractors and homeowners choose a direct local supplier over national broker platforms.',
    es: 'Mira exactamente por qué contratistas y propietarios eligen un proveedor local directo sobre plataformas de corredores nacionales.'
  },
  'lvn.advantage.th1': {
    en: 'Attribute',
    es: 'Atributo'
  },
  'lvn.advantage.th2': {
    en: '— Local Supplier',
    es: '— Proveedor Local'
  },
  'lvn.advantage.th3': {
    en: 'National Marketplace',
    es: 'Marketplace Nacional'
  },
  'lvn.adv.1.attr': {
    en: 'Delivery Speed',
    es: 'Velocidad de Entrega'
  },
  'lvn.adv.1.local': {
    en: 'Same-day & next-day. Trucks 30 min from your driveway.',
    es: 'Mismo día y día siguiente. Camiones a 30 min de tu entrada.'
  },
  'lvn.adv.1.nat': {
    en: 'Routed to the nearest hauler — could be days out.',
    es: 'Enviado al transportista más cercano — podría tardar días.'
  },
  'lvn.adv.2.attr': {
    en: 'Who Picks Up the Phone',
    es: 'Quién Contesta el Teléfono'
  },
  'lvn.adv.2.local': {
    en: 'The dispatcher loading your order.',
    es: 'El despachador que carga tu pedido.'
  },
  'lvn.adv.2.nat': {
    en: 'A call center or chatbot that opens a ticket.',
    es: 'Un centro de llamadas o chatbot que abre un ticket.'
  },
  'lvn.adv.3.attr': {
    en: 'Pricing',
    es: 'Precios'
  },
  'lvn.adv.3.local': {
    en: 'Direct from the supplier. No broker markup.',
    es: 'Directo del proveedor. Sin recargo de corredor.'
  },
  'lvn.adv.3.nat': {
    en: 'Marketplace fee on top of hauler price.',
    es: 'Tarifa de marketplace sobre el precio del transportista.'
  },
  'lvn.adv.4.attr': {
    en: 'Material Expertise',
    es: 'Experiencia en Materiales'
  },
  'lvn.adv.4.local': {
    en: 'We know what NW contractors actually spec — wet-soil base, drain rock, NW bark.',
    es: 'Sabemos lo que los contratistas del Noroeste realmente especifican — base para suelo húmedo, roca de drenaje, corteza del Noroeste.'
  },
  'lvn.adv.4.nat': {
    en: 'Generic catalog. No local soil/code knowledge.',
    es: 'Catálogo genérico. Sin conocimiento local de suelo/códigos.'
  },
  'lvn.adv.5.attr': {
    en: 'Accountability',
    es: 'Responsabilidad'
  },
  'lvn.adv.5.local': {
    en: "One number to call if something's wrong. Same crew next time.",
    es: 'Un solo número al cual llamar si algo sale mal. El mismo equipo la próxima vez.'
  },
  'lvn.adv.5.nat': {
    en: 'Disputes routed through marketplace support.',
    es: 'Disputas enviadas a través del soporte del marketplace.'
  },
  'lvn.adv.6.attr': {
    en: 'Trucks & Drivers',
    es: 'Camiones y Conductores'
  },
  'lvn.adv.6.local': {
    en: 'Our fleet, our drivers, every load.',
    es: 'Nuestra flota, nuestros conductores, cada carga.'
  },
  'lvn.adv.6.nat': {
    en: 'Whichever third-party hauler the system assigns.',
    es: 'Cualquier transportista externo que el sistema asigne.'
  },
  'lvn.adv.7.attr': {
    en: 'Where the Money Goes',
    es: 'A Dónde Va el Dinero'
  },
  'lvn.adv.7.local': {
    en: 'Stays in Pierce & King County.',
    es: 'Se queda en los condados de Pierce y King.'
  },
  'lvn.adv.7.nat': {
    en: 'Often routed out of state — sometimes out of country.',
    es: 'A menudo se envía fuera del estado — a veces fuera del país.'
  },
  'lvn.quote': {
    en: '"When you call 206Gravel, you\'re talking directly to the people scheduling and delivering your materials — not a ticket queue routing your job to a third-party hauler."',
    es: '"Cuando llamas a 206Gravel, hablas directamente con las personas que programan y entregan tus materiales — no con una cola de tickets que envía tu trabajo a un transportista externo."'
  },
  'lvn.why.title': {
    en: 'Why Local Matters',
    es: 'Por Qué lo Local Importa'
  },
  'lvn.why.1.title': {
    en: 'Talk to the People Loading Your Truck',
    es: 'Habla con la Gente que Carga tu Camión'
  },
  'lvn.why.1.desc': {
    en: 'No call centers. No ticket queues. When you call us, you speak directly to the dispatchers and drivers handling your order.',
    es: 'Sin centros de llamadas. Sin colas de tickets. Cuando nos llamas, hablas directamente con los despachadores y conductores que manejan tu pedido.'
  },
  'lvn.why.2.title': {
    en: 'No Marketplace Markup',
    es: 'Sin Recargos de Marketplace'
  },
  'lvn.why.2.desc': {
    en: 'National brokers add their cut on top of the material and delivery cost. We are the supplier, so you pay direct pricing.',
    es: 'Los corredores nacionales añaden su parte sobre el costo del material y la entrega. Nosotros somos el proveedor, así que pagas precios directos.'
  },
  'lvn.why.3.title': {
    en: 'Local Material Knowledge',
    es: 'Conocimiento Local de Materiales'
  },
  'lvn.why.3.desc': {
    en: 'We know Pierce and King County soil. We know what local inspectors look for. We deliver the exact spec you need for the Northwest.',
    es: 'Conocemos el suelo de los condados de Pierce y King. Sabemos lo que buscan los inspectores locales. Entregamos la especificación exacta que necesitas para el Noroeste.'
  },
  'lvn.why.4.title': {
    en: 'Boots on the Ground',
    es: 'Botas en el Terreno'
  },
  'lvn.why.4.desc': {
    en: 'Our fleet, our drivers. You get the same reliable crew load after load, building a relationship that matters on the jobsite.',
    es: 'Nuestra flota, nuestros conductores. Obtienes el mismo equipo confiable carga tras carga, construyendo una relación que importa en el sitio de trabajo.'
  },
  'lvn.why.5.title': {
    en: 'Faster Response When Plans Change',
    es: 'Respuesta Más Rápida Cuando los Planes Cambian'
  },
  'lvn.why.5.desc': {
    en: 'Jobsite delayed? Need an extra 10 yards ASAP? We can pivot in real-time because we control the trucks.',
    es: '¿Retraso en el sitio de trabajo? ¿Necesitas 10 yardas extra lo antes posible? Podemos adaptarnos en tiempo real porque controlamos los camiones.'
  },
  'lvn.why.6.title': {
    en: 'Your Dollars Stay Local',
    es: 'Tus Dólares se Quedan Localmente'
  },
  'lvn.why.6.desc': {
    en: 'We live and work in the 206. When you buy from us, your money stays in the local economy, not a tech hub out of state.',
    es: 'Vivimos y trabajamos en el 206. Cuando nos compras, tu dinero se queda en la economía local, no en un centro tecnológico fuera del estado.'
  },
  'lvn.faq.title': {
    en: 'Common Questions',
    es: 'Preguntas Comunes'
  },
  'lvn.faq.1.q': {
    en: "Aren't national marketplaces cheaper?",
    es: '¿No son más baratos los marketplaces nacionales?'
  },
  'lvn.faq.1.a': {
    en: "No — they add a marketplace fee on top of the hauler's rate. Because we are the direct supplier and operator, you skip the middleman markup and get honest, direct pricing.",
    es: 'No — añaden una tarifa de marketplace sobre la tarifa del transportista. Como somos el proveedor y operador directo, te saltas el recargo del intermediario y obtienes precios honestos y directos.'
  },
  'lvn.faq.2.q': {
    en: 'Can a local supplier handle big commercial jobs?',
    es: '¿Puede un proveedor local manejar trabajos comerciales grandes?'
  },
  'lvn.faq.2.a': {
    en: 'Absolutely. We deliver anywhere from 3 yards to 100+ yards. We offer automatic bulk discounts for orders of 15+ and 24+ yards, making us highly competitive for large contractor jobs.',
    es: 'Absolutamente. Entregamos desde 3 yardas hasta más de 100 yardas. Ofrecemos descuentos por volumen automáticos para pedidos de 15+ y 24+ yardas, haciéndonos altamente competitivos para grandes trabajos de contratistas.'
  },
  'lvn.faq.3.q': {
    en: "What if I'm outside Pierce or King County?",
    es: '¿Qué pasa si estoy fuera del condado de Pierce o King?'
  },
  'lvn.faq.3.a': {
    en: "While our standard zones cover King and Pierce County (as far north as Everett), we regularly do custom-quote runs to surrounding areas. Just call dispatch and we'll get you a rate.",
    es: 'Aunque nuestras zonas estándar cubren los condados de King y Pierce (tan al norte como Everett), regularmente hacemos viajes con cotización personalizada a áreas circundantes. Solo llama a despacho y te daremos una tarifa.'
  },
  'lvn.faq.4.q': {
    en: 'How fast can you actually deliver?',
    es: '¿Qué tan rápido pueden entregar realmente?'
  },
  'lvn.faq.4.a': {
    en: "Order before 12 PM and we book same-day automatically. After 12 PM, same-day is still often possible based on truck availability — call dispatch to lock it in. Because our trucks are local, we don't have the lag time of a national routing system.",
    es: 'Ordena antes de las 12 PM y reservamos el mismo día automáticamente. Después de las 12 PM, el mismo día sigue siendo a menudo posible según la disponibilidad de camiones — llama a despacho para confirmarlo. Como nuestros camiones son locales, no tenemos el tiempo de retraso de un sistema de enrutamiento nacional.'
  },
  'lvn.cta.title': {
    en: 'Ready to skip the marketplace?',
    es: '¿Listo para saltarte el marketplace?'
  },
  'lvn.cta.body': {
    en: "Get your materials from the local industry experts. We're 30 minutes from your driveway.",
    es: 'Obtén tus materiales de los expertos locales de la industria. Estamos a 30 minutos de tu entrada.'
  },
  'lvn.cta.btnQuote': {
    en: 'Get Instant Estimate',
    es: 'Obtener Presupuesto'
  },
  'lvn.cta.btnCall': {
    en: 'Call Dispatch',
    es: 'Llamar a Despacho'
  },
  // Promo Bar
  'promo.firstOrder': {
    en: 'First delivery? Save 10% with code',
    es: '¿Primera entrega? Ahorra 10% con el código'
  },
  'promo.firstOrderShort': {
    en: 'New? 10% off with',
    es: '¿Nuevo? 10% con'
  },
  'promo.tapToCopy': {
    en: '· tap to copy',
    es: '· toca para copiar'
  },
  'promo.copied': {
    en: 'Copied!',
    es: '¡Copiado!'
  },
  // How It Works
  'how.title.prefix': {
    en: 'How It',
    es: 'Cómo'
  },
  'how.title.highlight': {
    en: 'Works',
    es: 'Funciona'
  },
  'how.subtitle': {
    en: 'Simple, transparent, and fast delivery process.',
    es: 'Proceso de entrega simple, transparente y rápido.'
  },
  'how.step1.title': {
    en: 'Get a Quote',
    es: 'Obtén un Presupuesto'
  },
  'how.step1.desc': {
    en: 'Use our instant quote tool or give us a call to get pricing for your specific material and delivery location.',
    es: 'Usa nuestra herramienta de presupuesto instantáneo o llámanos para obtener precios para tu material y ubicación de entrega.'
  },
  'how.step2.title': {
    en: 'Schedule Delivery',
    es: 'Programa la Entrega'
  },
  'how.step2.desc': {
    en: 'Choose a delivery window that works for you. We offer same-day and next-day options for most materials.',
    es: 'Elige una ventana de entrega que te convenga. Ofrecemos opciones para el mismo día y al día siguiente para la mayoría de los materiales.'
  },
  'how.step3.title': {
    en: 'We Deliver',
    es: 'Entregamos'
  },
  'how.step3.desc': {
    en: 'Our professional drivers will deliver your materials exactly where you need them, safely and on time.',
    es: 'Nuestros conductores profesionales entregarán tus materiales justo donde los necesitas, con seguridad y a tiempo.'
  },
  // Why Us
  'why.localOwned': {
    en: 'Local Experts — Not a National Marketplace',
    es: 'Expertos Locales — No un Marketplace Nacional'
  },
  'why.localBody': {
    en: "Built and dispatched across the 253, 206, and 425. We're the local aggregate supplier serving King and Pierce County direct — same trucks, same drivers, same dispatcher every load. When you call, you're talking to the people scheduling and delivering your materials, not a call center routing tickets to a third-party hauler.",
    es: 'Construido y despachado en el 253, 206 y 425. Somos el proveedor local de agregados que sirve directamente a los condados de King y Pierce — los mismos camiones, los mismos conductores, el mismo despachador en cada carga. Cuando llamas, hablas con la gente que programa y entrega tus materiales, no con un centro de llamadas que reenvía boletos a un transportista externo.'
  },
  'why.feat1.title': {
    en: 'Local Trucks, Faster Delivery',
    es: 'Camiones Locales, Entrega Más Rápida'
  },
  'why.feat1.desc': {
    en: 'Our fleet is 30 minutes from your driveway. Same-day and next-day, no national queue.',
    es: 'Nuestra flota está a 30 minutos de tu entrada. Mismo día y siguiente día, sin cola nacional.'
  },
  'why.feat2.title': {
    en: 'Direct From the Supplier',
    es: 'Directo del Proveedor'
  },
  'why.feat2.desc': {
    en: "No broker markup, no national middleman. You pay for the rock and the run — that's it.",
    es: 'Sin recargo de intermediario, sin marketplace nacional. Pagas por la roca y el viaje — eso es todo.'
  },
  'why.feat3.title': {
    en: 'Real People on the Phone',
    es: 'Personas Reales al Teléfono'
  },
  'why.feat3.desc': {
    en: 'Call once, get the dispatcher loading your order — not a ticket queue or an AI agent.',
    es: 'Llama una vez y hablas con el despachador que carga tu pedido — no una cola de boletos ni un agente de IA.'
  },
  'why.feat4.title': {
    en: 'Knows the Northwest',
    es: 'Conoce el Noroeste'
  },
  'why.feat4.desc': {
    en: 'We know what NW contractors actually spec — wet-soil base, drain rock, NW bark — so you order right the first time.',
    es: 'Sabemos lo que los contratistas del Noroeste realmente especifican — base para suelos húmedos, roca de drenaje, corteza del Noroeste — para que pidas bien la primera vez.'
  },
  // CTA Banner
  'cta.headline1': {
    en: 'Need gravel',
    es: '¿Necesitas grava'
  },
  'cta.headline2': {
    en: 'delivered today?',
    es: 'entregada hoy?'
  },
  'cta.body': {
    en: 'Skip the wait. We offer fast, reliable delivery across the Puget Sound area. Same-day service available in most zones.',
    es: 'Sáltate la espera. Ofrecemos entrega rápida y confiable en toda el área de Puget Sound. Servicio el mismo día disponible en la mayoría de las zonas.'
  },
  'cta.getQuote': {
    en: 'Get Instant Quote',
    es: 'Obtener Presupuesto'
  },
  'cta.dispatchActive': {
    en: 'Dispatch is currently active',
    es: 'El despacho está activo en este momento'
  },
  'cta.dispatchOffline': {
    en: 'Dispatch is currently offline',
    es: 'El despacho está fuera de servicio'
  },
  // FAQ
  'faq.title': {
    en: 'Da FAQs',
    es: 'Las Preguntas Frecuentes'
  },
  'faq.subtitle': {
    en: "Quick answers about delivery, materials & pricing. If your question isn't listed below, just give us a call.",
    es: 'Respuestas rápidas sobre entrega, materiales y precios. Si tu pregunta no está listada abajo, solo llámanos.'
  },
  'faq.stillQuestions': {
    en: 'Still have questions?',
    es: '¿Aún tienes preguntas?'
  },
  'faq.shootText': {
    en: 'Shoot us a text.',
    es: 'Envíanos un mensaje.'
  },
  'faq.textUs': {
    en: 'Text Us',
    es: 'Envíanos un Mensaje'
  },
  'faq.q1': {
    en: 'What areas do you deliver to?',
    es: '¿A qué áreas entregan?'
  },
  'faq.q2': {
    en: 'What is the minimum order?',
    es: '¿Cuál es el pedido mínimo?'
  },
  'faq.a2': {
    en: 'Our minimum order is 3 cubic yards. Small orders (3–9 yds) include a small-load surcharge to cover dispatch costs.',
    es: 'Nuestro pedido mínimo es de 3 yardas cúbicas. Los pedidos pequeños (3–9 yds) incluyen un recargo por carga pequeña para cubrir los costos de despacho.'
  },
  'faq.q3': {
    en: 'Do you offer same-day delivery?',
    es: '¿Ofrecen entrega el mismo día?'
  },
  'faq.a3': {
    en: 'Yes! Order before 12 PM and we book same-day automatically. After 12 PM, same-day may still be possible based on truck availability — just call dispatch to check.',
    es: '¡Sí! Ordena antes de las 12 PM y reservamos el mismo día automáticamente. Después de las 12 PM, el mismo día aún puede ser posible según la disponibilidad de camiones — solo llama a despacho para confirmar.'
  },
  'faq.q4': {
    en: 'How do I know how much material I need?',
    es: '¿Cómo sé cuánto material necesito?'
  },
  'faq.q5': {
    en: 'What forms of payment do you accept?',
    es: '¿Qué formas de pago aceptan?'
  },
  'faq.a5': {
    en: 'We accept cash, check, and all major credit cards. Payment is due upon delivery.',
    es: 'Aceptamos efectivo, cheque y todas las tarjetas de crédito principales. El pago se realiza al momento de la entrega.'
  },
  'faq.q6': {
    en: 'Can I pick up materials instead of delivery?',
    es: '¿Puedo recoger los materiales en lugar de entrega?'
  },
  'faq.a6': {
    en: 'We are a delivery-only service at this time. All materials are delivered directly to your location by our professional drivers.',
    es: 'Por ahora somos un servicio solo de entrega. Todos los materiales son entregados directamente a tu ubicación por nuestros conductores profesionales.'
  },
  'faq.q7': {
    en: 'Do you spread the gravel after delivery?',
    es: '¿Esparcen la grava después de la entrega?'
  },
  // Footer
  'footer.tagline': {
    en: 'Premium gravel, crushed rock, and aggregate delivery serving Pierce and King counties — from Tacoma to Seattle and beyond. Fast, reliable, and transparent.',
    es: 'Entrega premium de grava, roca triturada y agregados sirviendo a los condados de Pierce y King — desde Tacoma hasta Seattle y más allá. Rápido, confiable y transparente.'
  },
  'footer.contact': {
    en: 'Contact',
    es: 'Contacto'
  },
  'footer.hours': {
    en: 'Hours',
    es: 'Horario'
  },
  'footer.resources': {
    en: 'Resources',
    es: 'Recursos'
  },
  'nav.resources': {
    en: 'Resources',
    es: 'Recursos'
  },
  'footer.monFri': {
    en: 'Mon-Fri:',
    es: 'Lun-Vie:'
  },
  'footer.saturday': {
    en: 'Saturday:',
    es: 'Sábado:'
  },
  'footer.sunday': {
    en: 'Sunday:',
    es: 'Domingo:'
  },
  'footer.closed': {
    en: 'Closed',
    es: 'Cerrado'
  },
  'footer.privacy': {
    en: 'Privacy',
    es: 'Privacidad'
  },
  'footer.terms': {
    en: 'Terms',
    es: 'Términos'
  },
  'footer.refund': {
    en: 'Refund Policy',
    es: 'Política de Reembolso'
  },
  'footer.rights': {
    en: 'All rights reserved.',
    es: 'Todos los derechos reservados.'
  },
  'footer.deliveryPrep': {
    en: 'Delivery Prep Guide',
    es: 'Guía de Preparación'
  },
  'footer.blog': {
    en: 'Blog',
    es: 'Blog'
  },
  'footer.materialQuiz': {
    en: 'Material Quiz',
    es: 'Cuestionario de Material'
  }
};
const productDescriptionsEs: Record<string, string> = {
  '5-8-minus': 'Nuestra grava más popular para entradas. Piedra angular finamente triturada con partículas hasta polvo, se compacta firmemente creando una superficie suave. Ideal para entradas, pasillos, bases de patio y como capa superior sobre roca base más gruesa.',
  '1-25-minus': 'Roca triturada gruesa con piezas hasta 1.25 pulgadas, mezclada con finos para excelente compactación. Capa base de servicio pesado — perfecta para construir entradas, base de carretera, áreas de estacionamiento y soporte estructural bajo concreto o adoquines.',
  '3-8-minus-driveway': 'Roca triturada más fina con piezas angulares hasta 3/8 pulgada y finos para un acabado apretado y suave. Compacta excepcionalmente bien, ideal para entradas, pasillos y patios donde quieres una superficie limpia y compacta.',
  'recycled-asphalt': 'Asfalto fresado y triturado de proyectos de carreteras y estacionamientos. El alquitrán residual se vuelve a unir con el calor, creando una superficie semi-dura resistente a la erosión. Popular para entradas rurales, caminos de granja y acceso temporal de construcción.',
  'recycled-concrete': 'Concreto triturado, cribado y dimensionado recuperado de proyectos de demolición locales. Se compacta bien y proporciona una base estable similar a la roca virgen. Opción inteligente y económica para base de carretera, sub-base de entradas y relleno detrás de muros.',
  'fill-dirt': 'Tierra de relleno limpia y cribada para aplicaciones no agrícolas. Úsala para nivelar grados, rellenar cimientos, llenar agujeros o construir áreas antes de colocar grava o césped. Es subsuelo — la forma más económica de mover tierra.',
  'builders-sand': 'Arena gruesa y lavada usada en construcción y paisajismo. Esencial para mezclar concreto y mortero, nivelar bases de adoquines, rellenar fosas y crear patios. Tamaño de grano consistente para resultados confiables.',
  'type-17-gravel-borrow': 'Mezcla natural de grava de mina con arena, limo y piedras redondeadas hasta 3 pulgadas. Cumple las especificaciones WSDOT Tipo 17 para relleno general y nivelación. Material asequible y versátil cuando necesitas volumen sin el costo de roca triturada.',
  '5-8-clear': 'Piedra triturada limpia y lavada sin finos ni polvo — solo piezas angulares de 5/8". El agua fluye libremente, ideal para drenajes franceses, drenajes cortina y zanjas de drenaje. También funciona como base para tuberías y detrás de muros de contención.',
  '1-25-clear': 'Piedra angular lavada más grande, cribada para eliminar todos los finos. Los espacios más grandes permiten flujo máximo de agua, ideal para drenaje pesado, campos sépticos, relleno de muros y manejo de aguas pluviales a gran escala.',
  '7-8-drain-rock': 'Roca limpia y redondeada de aproximadamente 7/8 pulgada — el estándar para drenajes franceses residenciales en el área de Puget Sound. Lavada sin finos para fácil paso de agua. Envuelve en tela filtrante para una instalación de drenaje perfecta.',
  '1-5-drain-rock': 'Roca de drenaje redondeada más grande para proyectos que necesitan mover mucha agua. Los huecos más grandes crean máxima capacidad de flujo, ideal para drenaje comercial, campos sépticos grandes y manejo pesado de agua. Limpia y lavada sin finos.',
  'pea-gravel': 'Piedras pequeñas, suaves y naturalmente redondeadas del tamaño de un guisante (alrededor de 3/8"). Disponible en mezcla de tonos tierra. Favorita versátil para senderos, áreas de juego, parques de perros y relleno entre adoquines. No se recomienda para entradas.',
  '3-way-topsoil': 'Nuestra mezcla premium para crecimiento — combinación equilibrada de tierra vegetal cribada, compost añejo y arena gruesa. La tierra proporciona estructura, el compost nutrientes y microbios, y la arena asegura drenaje. Ideal para nuevos céspedes y camas de jardín.',
  '50-50-mix': 'Mezcla rica 50/50 de tierra vegetal cribada y compost añejo, llena de materia orgánica y nutrientes. Perfecta para enmendar suelos arcillosos pesados comunes en Puget Sound y revitalizar camas de jardín cansadas.',
  compost: 'Compost orgánico rico y completamente añejado hecho de residuos de jardín y comida de origen local. Oscuro, desmenuzable y lleno de microbios y nutrientes. Úsalo para enmendar suelo, cubrir céspedes, enriquecer camas elevadas y huertos.',
  'fine-bark': 'Mantillo de corteza finamente triturada con textura suave y uniforme. Las piezas pequeñas crean una capa densa y ordenada que abraza el suelo, ideal para camas de jardín detalladas, bordes de flores y áreas donde quieres un look pulido.',
  'medium-bark': 'El mantillo de corteza más popular en el Pacífico Noroeste. Piezas medianas trituradas (1–3 pulgadas) que se asientan planas, se entrelazan bien y resisten el lavado en pendientes. Perfecto para camas de flores, bordes y alrededor de árboles.',
  'coarse-bark': 'Pepitas gruesas y duraderas de corteza (3–5 pulgadas) que resisten bien en áreas de mucho tráfico y ubicaciones expuestas. Las piezas más grandes se descomponen más lento. Excelente para camas grandes, propiedades comerciales y control de erosión.',
  'play-chips': 'Astillas naturales de cedro dimensionadas y cribadas para áreas de juego. Suaves, amortiguadoras y naturalmente resistentes a insectos y descomposición gracias a los aceites del cedro. Cumple los estándares ASTM F1292 a profundidad adecuada.',
  'streambed-cobble': 'Cantos rodados naturales en una mezcla de tamaños y tonos terrosos. De lechos de ríos regionales, traen una estética rugosa y natural a lechos de arroyos secos, características de agua y bordes de paisaje. Excelente para control de erosión.',
  'river-rock': 'Piedras suaves naturalmente pulidas en un rango de tamaños (2–6 pulgadas) y tonos terrosos. De lechos de ríos regionales, agregan un look pulido y orgánico. Úsalas para lechos de arroyos secos, características de agua y bordes decorativos.',
  'lava-rock': 'Roca volcánica ligera y porosa de color marrón rojizo profundo. Pesa aproximadamente la mitad que la grava regular, fácil de esparcir e ideal para jardineras de techo. La textura porosa retiene humedad y aísla raíces.',
  '2-inch-ballast': 'Piedra triturada angular de tamaño uniforme de aproximadamente 2 pulgadas. Originalmente especificada para vías férreas, valorada por su tamaño consistente y excelente distribución de carga. Ideal para capas base, estabilización de suelo blando y drenajes.',
  '2-4-quarry-rock': 'Piedra grande angular de cantera de 2 a 4 pulgadas. Demasiado grande para compactar en superficie suave, pero excelente para control de erosión, rip-rap a lo largo de zanjas, relleno pesado en áreas húmedas y caminos de acceso de construcción.',
  '4-8-quarry-spalls': 'Piedra angular extra grande de cantera de 4 a 8 pulgadas. Construida para los trabajos más duros — rip-rap pesado, control de erosión a gran escala, relleno estructural detrás de muros y armadura de salidas de drenaje.',
  'large-rocks': 'Rocas masivas de cantera de 1 a 4 hombres para control de erosión pesado, características de retención y armadura estructural. Tamaños desde 100 lbs hasta 2,000+ lbs. Ideal para rip-rap en bancos, protección de costas y muros grandes. Llama para disponibilidad.'
};
export function useProductDescription(product: {
  slug: string;
  description: string;
}): string {
  const {
    locale
  } = useLocale();
  if (locale === 'es' && productDescriptionsEs[product.slug]) {
    return productDescriptionsEs[product.slug];
  }
  return product.description;
}
export function getProductDescription(product: {
  slug: string;
  description: string;
}, locale: 'en' | 'es'): string {
  if (locale === 'es' && productDescriptionsEs[product.slug]) {
    return productDescriptionsEs[product.slug];
  }
  return product.description;
}
interface I18nContextType {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: string) => string;
}
const I18nContext = createContext<I18nContextType | undefined>(undefined);
export function I18nProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [locale, setLocaleState] = useState<Locale>(() => {
    try {
      const saved = localStorage.getItem('locale');
      return saved === 'en' || saved === 'es' ? saved : 'en';
    } catch {
      // Storage access can throw (private mode / blocked storage). Default
      // to English instead of crashing the outermost provider — a throw here
      // would blank the entire app.
      return 'en';
    }
  });
  const setLocale = (newLocale: Locale) => {
    setLocaleState(newLocale);
    try {
      localStorage.setItem('locale', newLocale);
    } catch {}
  };
  const t = (key: string): string => {
    if (!translations[key]) {
      console.warn(`Missing translation key: ${key}`);
      return key;
    }
    return translations[key][locale];
  };
  return <I18nContext.Provider value={{
    locale,
    setLocale,
    t
  }} data-id="element-3766" data-mp="b2d3crfrve7o">
      {children}
    </I18nContext.Provider>;
}
export function useT() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useT must be used within an I18nProvider');
  }
  return context.t;
}
export function useLocale() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useLocale must be used within an I18nProvider');
  }
  return {
    locale: context.locale,
    setLocale: context.setLocale
  };
}
export function LanguageToggle() {
  const {
    locale,
    setLocale
  } = useLocale();
  return <>
      {/* Mobile: single pill that toggles */}
      <button onClick={() => setLocale(locale === 'en' ? 'es' : 'en')} aria-label={`Switch language. Current: ${locale === 'en' ? 'English' : 'Spanish'}`} className="md:hidden flex items-center justify-center px-3 py-1 text-xs font-bold rounded-full bg-stone-100 dark:bg-[#2a2a2a] border border-stone-200 dark:border-[#333] text-stone-800 dark:text-stone-100 hover:bg-stone-200 dark:hover:bg-[#333] transition-colors" data-id="element-3767" data-mp="l607e5ffrfmh">
        {locale === 'en' ? 'EN' : 'ES'}
      </button>

      {/* Desktop: dual pill with sliding indicator */}
      <div className="hidden md:flex relative items-center bg-stone-100 dark:bg-[#2a2a2a] rounded-full p-0.5 border border-stone-200 dark:border-[#333]" data-id="element-3768" data-mp="1vu8uogshp5h2">
        <button onClick={() => setLocale('en')} className={`relative z-10 px-2.5 py-1 text-xs font-bold rounded-full transition-colors ${locale === 'en' ? 'text-white' : 'text-stone-500 dark:text-stone-400 hover:text-stone-800 dark:hover:text-stone-200'}`} data-id="element-3769" data-mp="3q2l3h5lzklzs">
          EN
        </button>
        <button onClick={() => setLocale('es')} className={`relative z-10 px-2.5 py-1 text-xs font-bold rounded-full transition-colors ${locale === 'es' ? 'text-white' : 'text-stone-500 dark:text-stone-400 hover:text-stone-800 dark:hover:text-stone-200'}`} data-id="element-3770" data-mp="3la1rgd2y5yx3">
          ES
        </button>
        <motion.div className="absolute top-0.5 bottom-0.5 w-[calc(50%-2px)] bg-stone-700 dark:bg-stone-600 rounded-full shadow-sm" initial={false} animate={{
        left: locale === 'en' ? '2px' : 'calc(50%)'
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} data-id="element-3771" data-mp="2xegy6l7buaxm" />
      </div>
    </>;
}